module.exports = __webpack_public_path__ + "4f0d7d62a697fd22f5572661cb6db842.jpg";